import "./CompanyServices.module.css";
import GatewayNavigation from "@/reusable_sections/Header";
import AboutHero from "./sections/AboutHero";
import ServicesAuxProprietaires from "./sections/ServicesAuxProprietaires";
import AgendaTuVisita from "./sections/AgendaTuVisita";
import Footer from "@/reusable_sections/Footer";
export default function CompanyServicesPage() {
  return <div>
      <GatewayNavigation />
      <AboutHero />
      <ServicesAuxProprietaires />
      <AgendaTuVisita />
      <Footer />
    </div>;
}